import IConfig from './Interfaces/IConfig';

import ConfigAnalytics from './ConfigAnalytics';
import ConfigBehaviour from './ConfigBehaviour';
import ConfigCaptions  from './ConfigCaptions';
import ConfigDrm       from './ConfigDrm';
import ConfigText      from './ConfigText';
import ConfigWatermark from './ConfigWatermark';

class Config implements IConfig {
    public captions = new ConfigCaptions();
    public behaviour = new ConfigBehaviour();
    public watermark = new ConfigWatermark();
    public drm = new ConfigDrm();
    public analytics = new ConfigAnalytics();
    public text = new ConfigText();

    constructor() {
        Object.freeze(this);
    }
}

export default Config;